import React from 'react'
import { useTranslation } from 'react-i18next'
import Html from '../Html'
import styles from './styles.module.css'

function SearchEmptyState({ query }) {
  const { t } = useTranslation()

  return (
    <Html as="span" className={styles.searchEmptyState}>
      {t('general.searchNotFound', { query })}
    </Html>
  )
}

export default SearchEmptyState
